import styled from 'styled-components';
import { Grid } from '@increasecard/typed-components';

export const TextContainer = styled.div`
  border-radius: 9px;
  display: flex;
  flex-direction: column;
  height: 243px;
  padding: 16px;
  width: 100%;
`;

export const TextWrapper = styled(Grid)`
  margin: 36px 16px;
`;

export const TextList = styled.ul`
  list-style: none;
  margin-top: 20px;
  li {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  li {
    &::before {
      content: '\\2022';
      color: ${({ theme }) => theme.colorsNew.card.regular};
      font-weight: bold;
      display: inline-block;
      width: 1em;
    }
  }
`;
